/* Copyright (c) 2020-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import {
    ComponentRef,
    Directive,
    Input,
    OnChanges,
    OnDestroy,
    Renderer2,
    SimpleChanges,
    ViewContainerRef
} from '@angular/core';
import { Logger, LoggingService } from 'crimson/lib/logging/logging.service';
import { HigProgressCircularDefaultDiameter } from '../components/nv-hig-progress/nv-hig-progress';
import { NvHigProgressCircularComponent } from '../components/nv-hig-progress/nv-hig-progress-circular.component';

@Directive({
    selector: '[nvProgressCircular]',
    standalone: true
})
export class NvProgressCircularDirective implements OnChanges, OnDestroy {
    private logger: Logger;
    @Input() isVisible: boolean;
    @Input() diameter = HigProgressCircularDefaultDiameter;
    private spinnerComponentRef: ComponentRef<NvHigProgressCircularComponent>;
    private spinnerComponentNativeElement = null;

    constructor(
        private viewcontainerRef: ViewContainerRef,
        private renderer: Renderer2,
        loggingService: LoggingService
    ) {
        this.logger = loggingService.getLogger('nvProgressCircularDirective');
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.isVisible && changes.isVisible.currentValue !== changes.isVisible.previousValue) {
            if (changes.isVisible.currentValue) {
                this.createSpinner();
            } else {
                this.destroySpinner();
            }
        }
    }

    ngOnDestroy() {
        this.destroySpinner();
    }

    private createSpinner() {
        this.spinnerComponentRef = this.viewcontainerRef.createComponent(NvHigProgressCircularComponent);
        this.spinnerComponentNativeElement =
            this.spinnerComponentRef.injector.get(NvHigProgressCircularComponent).viewRef.element.nativeElement;
        this.renderer.appendChild(this.viewcontainerRef.element.nativeElement, this.spinnerComponentNativeElement);
    }

    private destroySpinner() {
        if (this.spinnerComponentNativeElement) {
            this.renderer.removeChild(this.viewcontainerRef.element.nativeElement, this.spinnerComponentNativeElement);
        }
        if (this.spinnerComponentRef) {
            this.spinnerComponentRef.destroy();
        }
        this.spinnerComponentNativeElement = null;
    }
}
